import { applicantFullNameFromFields, selectedOptionText, statusMatchField } from "../utils/status_match_form"
import { matchedAirlineKey, matchedReward, reviewSummary, validationReview } from "./review_sync"

export const typeformReview = {
  wizardForm() {
    if (this.hasWizardFormTarget) return this.wizardFormTarget
    return this.element.querySelector("form[action*='status_match_applications']")
  },

  syncReviewSummaryFromForm() {
    const form = this.wizardForm()
    if (!form) return

    const emptyLabel = this.t("placeholders.empty", "Not yet")
    const selectPrefix = this.t("placeholders.select", "Select")
    const pendingTier = this.t("placeholders.pending_tier", "--")
    const summary = reviewSummary(form, {
      emptyLabel,
      selectPrefix,
      defaultProgramme: this.defaultOriginProgrammeValue || this.t("journey_card.open_programme", "Choose airline"),
      defaultTier: this.defaultOriginTierValue,
      pendingTier,
      pendingReward: this.t("journey_card.destination_pending", "Target status"),
      criteria: this.criteriaValue
    })
    Object.entries(summary).forEach(([key, value]) => {
      this._setReviewOut(key, value)
    })
    this.syncMatchedCampaign()

    const method = form.querySelector('input[name="status_match_application[validation_method]"]:checked')?.value
    const vr = validationReview(this.element, method, emptyLabel)
    this._setReviewOut("validation_method", vr.method)
    const statusEl = this.reviewStepTarget?.querySelector('[data-review-out="validation_status"]')
    if (statusEl) {
      statusEl.textContent = vr.status
      statusEl.dataset.reviewStatusTone = vr.tone
      statusEl.className = this._validationStatusPillClasses(vr.tone)
    }

    this.syncScreenShareExpected()
  },

  t(path, fallback) {
    const value = path.split(".").reduce((memo, key) => memo?.[key], this.i18nValue)
    return value == null || value === "" ? fallback : value
  },

  _validationStatusPillClasses(tone) {
    const base = "inline-flex rounded-full px-2.5 py-1 text-xs font-semibold "
    if (tone === "amber") {
      return `${base}bg-amber-50 text-amber-950 ring-1 ring-amber-200/90`
    }
    return `${base}bg-sky-50 text-sky-950 ring-1 ring-sky-200/90`
  },

  _setReviewOut(key, text) {
    const root = key.startsWith("banner_") && this.hasJourneyCardTarget
      ? this.journeyCardTarget
      : this.hasReviewStepTarget
        ? this.reviewStepTarget
        : this.element
    root.querySelectorAll(`[data-review-out="${key}"]`).forEach((el) => {
      el.textContent = text
      if (key === "banner_tier" || key === "banner_reward_tier") {
        const modifier = this.criteriaValue.tier_chip_modifiers?.[text] || "journey-tier-chip--pending"
        el.className = `landing-apply-flow__chip wizard-journey-card__chip ${modifier}`
      }
    })
  },

  syncMatchedCampaign() {
    const form = this.wizardForm()
    if (!form) return

    const canonicalAirline = statusMatchField(form, "origin_airline")
    const enteredAirline = statusMatchField(form, "origin_airline_input")
    const reward = matchedReward(
      this.criteriaValue,
      matchedAirlineKey(
        this.criteriaValue,
        canonicalAirline?.value ? canonicalAirline : enteredAirline
      ),
      statusMatchField(form, "origin_tier")?.value
    )
    const campaignId = reward?.campaign_id

    const hidden = form.querySelector('[name="status_match_application[status_match_campaign_id]"]')
    if (hidden) hidden.value = campaignId == null ? "" : String(campaignId)
  },

  syncReviewSubmitEnabled() {
    const form = this.wizardForm() || this.element
    const accuracy = form.querySelector(
      'input[type="checkbox"][name="status_match_application[consent_given]"]'
    )?.checked
    const privacy = form.querySelector(
      'input[type="checkbox"][name="status_match_application[consent_privacy_accepted]"]'
    )?.checked
    const ok = Boolean(accuracy && privacy)

    const submit = this.hasReviewSubmitTarget ? this.reviewSubmitTarget : null
    if (!submit) return

    submit.disabled = !ok
    submit.setAttribute("aria-disabled", ok ? "false" : "true")
  },

  syncScreenShareExpected() {
    const form = this.wizardForm()
    if (!form || !this.hasScreenShareFlowTarget) return

    const dash = this.t("placeholders.empty", "Not yet")
    const selectPrefix = this.t("placeholders.select", "Select")
    const name = applicantFullNameFromFields(form)
    const membership = statusMatchField(form, "origin_membership_number")?.value?.trim() || ""
    const tier = selectedOptionText(statusMatchField(form, "origin_tier"), selectPrefix)

    this._setScreenShareExpected("name", name || dash)
    this._setScreenShareExpected("membership", membership || dash)
    this._setScreenShareExpected("tier", tier || dash)
  },

  _setScreenShareExpected(key, text) {
    this.screenShareFlowTarget.querySelectorAll(`[data-screen-share-expected="${key}"]`).forEach((el) => {
      el.textContent = text
    })
  }
}
